import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from "@Components/modal";
import {MODALS_IDS} from "@Components/modal-container";
import {LazyPanel} from "@Components/lazy-panel";
import {useModalData} from "@Components/modal/hooks/useModalData";
import {openPanelInModal} from "@Components/modal-container/modal-container-reducer";
import type {DesignSelectorPanelProps} from "@Panels/design-selector-panel/design-selector-panel";

export const PANEL_ID = 'design-selector-panel';
export type DesignSelectorModalProps = DesignSelectorPanelProps;

export default function SocialMediaAddDesignModal(): ReactElement {
  const modalData = useModalData(MODALS_IDS.DESIGN_SELECTOR_MODAL);
  const modalHeight = '95%';
  const modalWidth = '100%';

  return (
    <Modal modalId={MODALS_IDS.DESIGN_SELECTOR_MODAL} panelId={PANEL_ID} modalHeight={modalHeight} modalWidth={modalWidth} >
      <LazyPanel
        lazyPanelId={PANEL_ID}
        panelDirectoryName="design-selector-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openDesignSelectorModal = (props: DesignSelectorModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.DESIGN_SELECTOR_MODAL,
      panelProps: props,
    })
  );
};